import { render, staticRenderFns } from "./mdLoading.vue?vue&type=template&id=45f5510e&scoped=true&"
import script from "./mdLoading.vue?vue&type=script&lang=js&"
export * from "./mdLoading.vue?vue&type=script&lang=js&"
import style0 from "./mdLoading.vue?vue&type=style&index=0&id=45f5510e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f5510e",
  null
  
)

export default component.exports